import Vue from "vue";
import Vuex from "vuex";
import BrowserStorage from "./utils/utils-browser-storage";
import appServices from "./request-server/request-services/app-services";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //授权Token,这里只是用来保存一下方便读取，实际token是存在了localstorage
    token: null,
    //当前登录用户信息
    user: {
      //名字
      name: "",
      //头像
      avatar: "",
      phone:'',
      //权限
      permissions: [],
    },
    unitInfo:{
      UnitId:'',
      AthletePhotoFilePaths:[]
    },
    axios: {
      //当前页面发生的请求取消列表
      curPageReqsCancel: []
    },
    matchIdCookie: '',
    curPageReqsCancel: [],
    referee: {
      heartInterval: null,
      curRefereeInfo: null,
      k1: null,
      k2: null,
      uid: null,
      userupdate: null,
    }
  },
  mutations: {
    //登入（登录）
    loginin: (state, data) => {
      BrowserStorage.setItem("token", data);
      state.token = data;
    },
    //登出（退出登录）
    loginout: (state) => {
      BrowserStorage.removeItem("token");
      state.token = null;
    },
    //设置用户权限
    setUserPermission: (state, data) => {
      state.user.permissions = data;
    },
    //刷新用户信息
    updateUserInfo: (state, data) => {
      state.user.name = data.LoginName;
      state.user.phone = data.AccPhone;
    },
    updateUnitInfo: (state, data) => {
      state.unitInfo = data;
    },
    //加入请求取消事件列表
    pushReqCancel: (state, src) => {
      state.axios.curPageReqsCancel.push(src);
    },
    //清除取消事件列表
    cleanReqCancel: (state) => {
      state.axios.curPageReqsCancel.forEach((item) => {
        item("canclereq-01");
      });
      state.axios.curPageReqsCancel = [];
    },
    matchIdCookie: (state, data) => {
      state.matchIdCookie = data;
    },
    saveHeartInterval: (state, i) => {
      state.referee.heartInterval = i;
    },
    cleanHeartInterval: (state) => {
      if (state.referee.heartInterval) {
        clearInterval(state.referee.heartInterval);
        state.referee.heartInterval = null;
      }
    },
    setRefereeInfo: (state, data) => {
      let refereeInfo = BrowserStorage.getItem("refereeInfo");
      if (data) {
        BrowserStorage.setItem(
          "refereeInfo",
          JSON.stringify(data),
          7 * 24 * 60 * 60 * 1000
        );

        state.referee.curRefereeInfo = data;
      } else {
        state.referee.curRefereeInfo = JSON.parse(refereeInfo);
      }
    },
    cleanRefereeInfo: (state) => {
      state.referee.curRefereeInfo = null;
      BrowserStorage.removeItem("refereeInfo");
    },
    setRefereeCacheKey: (state, data) => {
      //BrowserStorage.setItem("refereeCache", JSON.stringify(data), 7 * 24 * 60 * 60 * 1000);
      state.referee.k1 = data.k1;
      state.referee.k2 = data.k2;
    },
    cleanRefereeCacheKey: (state) => {
      state.referee.k1 = null;
      state.referee.k2 = null;
      //BrowserStorage.removeItem("refereeCache");
    },
    setRefereeUid: (state, data) => {
      state.referee.uid = data;
    },
    setRefereeUpdateUserTime: (state, data) => {
      state.referee.userupdate = data;
    },
  },
  actions: {
    setRefereeInfo({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        if (data && data.refereeInfo) {
          commit("setRefereeInfo", data.refereeInfo);
        } else {
          commit("setRefereeInfo");
        }
        if (state.referee.curRefereeInfo) {
          appServices
            .SetRefereeInfo(state.referee.curRefereeInfo)
            .then((res) => {
              let apiRes = res.data;
              commit("setRefereeCacheKey", apiRes);
              resolve();
            })
            .catch(() => {
              commit("cleanRefereeInfo");
              commit("cleanRefereeCacheKey");
              reject();
            });
        } else {
          resolve();
        }
      });
    },
  },
});
